module.exports = __webpack_public_path__ + "static/media/logowhite.68220d97.png";